import { Badge, Icon, Tooltip } from "@oysterhr/ui"
import { useTranslation } from "react-i18next"
import { TRUST_LEVELS } from "./constants"
import { TrustLevelEnum } from "@oysterhr/schema"

interface TrustLevelProps {
  trustLevel?: TrustLevelEnum
}

export const TrustLevel = ({ trustLevel }: TrustLevelProps) => {
  const { t } = useTranslation("global_compensation_calculator/Result", {
    keyPrefix: "trustLevel",
  })

  if (!trustLevel || trustLevel === TrustLevelEnum.None) return null

  const { variation, titleKey } = TRUST_LEVELS[trustLevel]

  return (
    <div className="flex w-fit items-center">
      <Badge variation={variation} className="mr-1 text-primary-base">
        {t(titleKey)} {t("data")}
      </Badge>
      <Tooltip value={t("tooltip")} placement="bottom-end">
        <div>
          <Icon name="InfoCircle" />
        </div>
      </Tooltip>
    </div>
  )
}
